import React, { PropTypes, Component } from 'react'
import Logo from './Logo'
import Sharing from './Sharing'
import DotsIcon from './icons/dots.svg'
import { typography } from '../styles'
import constants from '../constants'
import $ from 'jquery'
import styled from 'styled-components'

const Trigger = styled.a`
  cursor: pointer;
  position: relative;
  z-index: 50;
  position: fixed;
  ${props => props.displayNavigation ? 'right: 0;' : 'left: 50%;'};
  bottom: 0;
  padding: 5px;
  transform: translate(-50%, 0);
`
const Modal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 30;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    flex-direction: column;
    text-align: center;
  }
  ${props => props.animating && props.active === constants.SHOW_LYRIC &&
    'animation: to-foreground 0.5s ease-in-out both; pointer-events: none;'}
  ${props => props.animating && props.active === constants.SHOW_OVERLAY &&
    'animation: from-foreground 0.5s ease-in-out both;'}
`
const Content = styled.div`
  position: relative;
  z-index: 32;
  animation: fade-in 0.3s ease-in-out both 0.25s;
`
const Background = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #000;
  background-size: cover;
  z-index: 31;
  transition: opacity 0.5s ease 0.5s;
  display: block;
  opacity: ${props => props.src ? 1 : 0};
`
const Links = styled.div`
  ${typography.serif}
  font-size: 0.875rem;
  margin-top: 0.5rem;
  > * {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    border-bottom: 1px solid currentColor;
  }
  > * + * {
    margin-left: 1rem;
  }
`

class Overlay extends Component {
  constructor () {
    super()
    this.state = {src: false}
  }
  componentDidMount () {
    const image = new window.Image()
    $(image).on('load', () => { this.setState({src: image.src}) })
    image.src = `${process.env.PUBLIC_URL}/images/artwork.jpg`
  }
  render () {
    let {active, animating, toggleOverlay, displayOverlay, displayNavigation} = this.props
    return (
      <div>
        <Trigger displayNavigation={displayNavigation} onClick={toggleOverlay} title='More information'>
          <img src={DotsIcon} role='presentation' />
        </Trigger>
        {displayOverlay
          ? <Modal active={active} animating={animating} ref='modal'>
            <Background ref='background' src={this.state.src} style={{backgroundImage: `url(${this.state.src})`}} />
            <Content>
              <Logo />
              <Links>
                <a href='https://lnk.to/svDFG' target='_blank'>Purchase</a>
                <a href='https://lnk.to/svDFG' target='_blank'>Stream</a>
              </Links>
              <Sharing />
            </Content>
          </Modal>
          : null}
      </div>
    )
  }
}

Overlay.propTypes = {
  displayOverlay: PropTypes.bool,
  displayNavigation: PropTypes.bool,
  toggleOverlay: PropTypes.func,
  active: PropTypes.string,
  animating: PropTypes.bool
}

export default Overlay



/** WEBPACK FOOTER **
 ** ./src/components/Overlay.js
 **/